/** Helpers for the SmartSheet import page; pure so they can be tested. */

export const ROW_STATUS = {
    READY: { label: 'Ready', color: 'success' },
    CONFLICT: { label: 'Needs a decision', color: 'warning' },
    ERROR: { label: 'Problem', color: 'error' },
    DUPLICATE: { label: 'Duplicate row', color: 'error' },
    ALREADY_OPEN: { label: 'Already tracked', color: 'default' },
    DONE: { label: 'Already finished', color: 'default' },
};

export const RESULT_STATUS = {
    CREATED: { label: 'Imported', color: 'success' },
    SKIPPED: { label: 'Skipped', color: 'default' },
    FAILED: { label: 'Failed', color: 'error' },
};

export const DECISIONS = {
    SMARTSHEET: 'Trust SmartSheet',
    EDITOR: 'Trust the editor',
    SKIP: 'Skip',
};

export const TEMPLATE_CSV =
    'Title,Content ID,Language,Current Stage,Assignee,PM,Due Date,Watchers,Posting Date,Category,Duration\n' +
    'Satsang 12,,Hindi,Translation round 2,translator@example.org,pm@example.org,21/10/2026,,14/11/2026,Reels,12:30\n';

/** Rows that can be imported: ready ones, and conflicts once decided. */
export const importable = (row) => row.status === 'READY' || row.status === 'CONFLICT';

/**
 * What the PM still has to do before importing, as readable sentences (empty = ready).
 * @param {object} dry - the dry run result
 * @param {object} decisions - line number to SMARTSHEET, EDITOR or SKIP
 */
export const importBlockers = (dry, decisions) => {
    if (!dry) return ['Choose a file first.'];
    const undecided = dry.rows.filter((r) => r.status === 'CONFLICT' && !decisions[r.line]).length;
    const toCreate = dry.rows.filter((r) => importable(r) && decisions[r.line] !== 'SKIP').length;
    const out = [];
    if (undecided > 0) {
        out.push(
            undecided === 1
                ? 'Choose what to do with the row that needs a decision.'
                : `Choose what to do with the ${undecided} rows that need a decision.`,
        );
    }
    if (toCreate === 0 && undecided === 0) {
        out.push('No rows to import.');
    }
    return out;
};

/** How many tasks importing now would create. */
export const importCount = (dry, decisions) =>
    dry ? dry.rows.filter((r) => importable(r) && decisions[r.line] !== 'SKIP').length : 0;
